export default __webpack_public_path__ + "static/material_04-763395f74f6f94220f4001ac8c399279.png";